import { Heading as ThemeUIHeading } from 'theme-ui';

const Heading = (props) => (
  <ThemeUIHeading mb={6} {...props}>
    {props.children}
  </ThemeUIHeading>
);

export default Heading;
